import { useState, useEffect, useRef } from "react";

export default function InstructiveVideo() {
    const [watchProgress, setWatchProgress] = useState(0);
    const [videoCompleted, setVideoCompleted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const videoRef = useRef(null);
    const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;

    const videoUrl = "https://res.cloudinary.com/dhunrxpuq/video/upload/Motivation_ehbb7q.mp4";

    // Gestion simple de la progression
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const updateProgress = () => {
            const progress = (video.currentTime / video.duration) * 100;
            setWatchProgress(progress);

            if (progress >= 95) {
                setVideoCompleted(true);
            }
        };

        video.addEventListener("timeupdate", updateProgress);
        return () => video.removeEventListener("timeupdate", updateProgress);
    }, []);

    // Soumettre au backend
    const handleSubmit = async () => {
        if (submitting || !videoCompleted) return;

        setSubmitting(true);

        try {
            const token = localStorage.getItem("token");

            const res = await fetch(`${apiUrl}/api/tasks/video-submit/instructive`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    taskType: "instructive_video",
                    completedAt: new Date().toISOString(),
                }),
            });

            const data = await res.json();

            if (data.status === "success") {
                setSubmitSuccess(true);
            }
        } catch (err) {
            console.error("Erreur:", err);
        } finally {
            setSubmitting(false);
        }
    };

    //Bloquage de l'affichage

    if (true)
        return (
            <>
                <div className="bg-purple-50 border-l-4 border-red-500 rounded-lg p-4">
                    <h4 className="font-bold text-red-800 mb-2">ℹ️ Infomation</h4>
                    <ul className="text-sm text-red-700 space-y-1">
                        <li>Vidéo indisponible pour le moment</li>
                        <li>Nous travaillons pour résoudre le problème au plus vite</li>
                    </ul>
                </div>
            </>
        )


    // Succès
    if (submitSuccess) {
        return (
            <div className="space-y-4 pb-20 px-4">
                <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg shadow-md p-6 text-white text-center">
                    <div className="text-5xl mb-4">🎉</div>
                    <h2 className="text-2xl font-bold mb-2">Vidéo visionnée !</h2>
                    <p className="mb-4">Félicitations, tâche accomplie</p>
                    <div className="bg-yellow-400 text-yellow-900 rounded-lg p-3">
                        <p className="font-bold">✅ Récompense créditée</p>
                    </div>
                </div>
            </div>
        );
    }

    // Interface principale
    return (
        <div className="space-y-4 pb-20 px-4">
            {/* Header */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 text-center">
                    Vidéo Instructive
                </h2>
                <p className="text-sm text-gray-600 mb-4 text-center">
                    Regardez la vidéo en entier pour valider
                </p>

                {/* Barre de progression */}
                <div className="bg-gray-200 rounded-full h-3 mb-2">
                    <div
                        className="bg-gradient-to-r from-purple-500 to-indigo-600 h-3 rounded-full transition-all"
                        style={{ width: `${watchProgress}%` }}
                    ></div>
                </div>

                <div className="flex justify-between text-sm text-gray-600">
                    <span>Progression</span>
                    <span className="font-bold text-purple-600">
                        {Math.round(watchProgress)}%
                    </span>
                </div>
            </div>

            {/* Vidéo */}
            <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
                <div className="aspect-video bg-black rounded-lg overflow-hidden mb-4">
                    <video
                        ref={videoRef}
                        className="w-full h-full object-contain"
                        controls
                        playsInline
                    >
                        <source src={videoUrl} type="video/mp4" />
                    </video>
                </div>

                {/* Statut */}
                {videoCompleted ? (
                    <div className="bg-green-50 border-l-4 border-green-500 rounded-lg p-4 mb-4">
                        <p className="text-green-800 font-bold">✅ Vidéo terminée !</p>
                        <p className="text-sm text-green-700">Vous pouvez valider</p>
                    </div>
                ) : (
                    <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4 mb-4">
                        <p className="text-blue-800 font-bold">▶️ En cours...</p>
                        <p className="text-sm text-blue-700">Regardez jusqu'à la fin</p>
                    </div>
                )}

                {/* Bouton */}
                <button
                    onClick={handleSubmit}
                    disabled={!videoCompleted || submitting}
                    className={`w-full font-bold py-3 px-6 rounded-lg transition ${!videoCompleted || submitting
                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white shadow-lg"
                        }`}
                >
                    {submitting ? "Validation..." : videoCompleted ? "✅ Valider" : "Terminez la vidéo"}
                </button>
            </div>

            {/* Info */}
            <div className="bg-purple-50 border-l-4 border-purple-500 rounded-lg p-4">
                <h4 className="font-bold text-purple-800 mb-2">ℹ️ Guide</h4>
                <ul className="text-sm text-purple-700 space-y-1">
                    <li>• Regardez la vidéo en entier (minimum 95%)</li>
                    <li>• Cliquez sur Valider pour obtenir votre récompense</li>
                </ul>
            </div>
        </div>
    );
}